module.exports = __webpack_public_path__ + "img/current-badge-overall.7429f40e.svg";